import { downloadBlobInBrowser, isTauriEnvironment, saveBlobWithTauri } from './downloadHelpers';
import { resolveDownloadFileName } from './downloadFileName';

export const getAttachmentSources = (attachment, image = false) => [...new Set([
    attachment?.url,
    attachment?.cdn_url,
    ...(image ? [attachment?.thumbnail?.original, attachment?.thumbnail?.xl, attachment?.thumbnail?.lg,
        attachment?.thumbnail?.md, attachment?.thumbnail?.sm] : [])
].filter(source => typeof source === 'string' && source.trim()))];

export const downloadReadOnlyAttachment = async (attachment, image = false) => {
    for (const source of getAttachmentSources(attachment, image)) {
        let blob;
        try {
            const response = await fetch(source);
            if (!response.ok) continue;
            blob = await response.blob();
            if (image && !blob.type.startsWith('image/')) continue;
        } catch (_) { continue; }
        let filename = resolveDownloadFileName(attachment.name, attachment.displayName || attachment.name || (image ? 'image' : 'file'));
        if (image && !filename.includes('.')) {
            const extension = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/gif': 'gif', 'image/avif': 'avif' }[blob.type];
            if (extension) filename += `.${extension}`;
        }
        // Save failures are surfaced rather than starting another download.
        if (isTauriEnvironment()) return saveBlobWithTauri(blob, filename);
        downloadBlobInBrowser(blob, filename);
        return true;
    }
    throw new Error('Attachment unavailable');
};
